var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuSignalFan1Variable = function SvgDAhuSignalFan1Variable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 105,
    r: 11,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,95c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S218.5,95,224,95 M224,94c-6.1,0-11,4.9-11,11 s4.9,11,11,11s11-4.9,11-11S230.1,94,224,94L224,94z",
    fill: "#1C9D5B"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "219.3,110 228.6,100.7 227.9,100 218.6,109.3 218.6,98.7 217.6,98.7 217.6,111 229.9,111 229.9,110"
  })))));
};
export default SvgDAhuSignalFan1Variable;